import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {environment} from '@env/environment';

@Injectable()
export class MaintenanceGuard implements CanActivate {

    readonly TESTING_QUERY_PARAM = 'testingaftermaintenance';
    readonly TRUE = 'true';

    constructor(private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (environment.maintenance) {
            const isTestingActive = this.restoreTestingParamToLocalStorage() === this.TRUE;

            if (!isTestingActive) {
                this.router.navigate(['/maintenance']);
                return false;
            }
        }
        return true;
    }

    private restoreTestingParamToLocalStorage(): string {
        return window.localStorage.getItem(this.TESTING_QUERY_PARAM);
    }
}
